<template>
  <b-field
    :label="label"
    :message="errorMessage || message"
    :type="errorMessage ? 'is-danger' : ''"
  >
    <b-select
      :value="trackerInterval"
      label="Choisir un intervalle"
      icon="user"
      expanded
      @input="$emit('update:trackerInterval', $event)"
    >
      <option :value="null">–</option>
      <option v-for="interval in trackerIntervals" :key="interval.value" :value="interval.value">
        {{ interval.label }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import {
  TRACKER_INTERVAL_DEFAULT,
  TRACKER_INTERVAL_IDLE,
  TRACKER_INTERVAL_PERFORMANCE,
  TRACKER_INTERVALS,
} from '@constants/tracker/interval'

export default {
  name: 'TrackerIntervalField',

  props: {
    label: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    trackerInterval: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },

  created() {
    this.trackerIntervals = TRACKER_INTERVALS.map((interval) => {
      if (interval === TRACKER_INTERVAL_DEFAULT) {
        return {
          value: interval,
          label: 'Défaut (Équilibré entre précision et consommation de ressources)',
        }
      }

      if (interval === TRACKER_INTERVAL_PERFORMANCE) {
        return {
          value: interval,
          label: 'Performance (Intervalle court pour un suivi fréquent et précis.)',
        }
      }

      if (interval === TRACKER_INTERVAL_IDLE) {
        return {
          value: interval,
          label: 'Repos (Intervalle long, idéal pour les phases de distribution ou de repos)',
        }
      }

      return interval
    })
  },

  watch: {
    errorMessage(errorMessage) {
      this.$emit('error', errorMessage !== null)
    },
  },
}
</script>
